/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import _ from 'lodash';

import lazyLoadView from '@/util/lazyLoadView';

import IntDashboardSidebarNavView from '../../../internal-dashboard/views/IntDashboardSidebarNavView';
import loadSearchFields from '../../../login/loaders/SearchFieldsViewLoader';
import FindExternalUserByNameOrEmailOrCommandName from '../../../administration/services/FindExternalUserByNameOrEmailOrCommandName';
import CustomerDashboardGridView from '../../views/CustomerDashboardGridView';

import tmplCustomerDashboardPage from './CustomerDashboardPage.hbs';

const CustomerDashboardPage = View.extend({
  template: tmplCustomerDashboardPage,

  ui: {
    sideBar: '.sidebar-nav-container',
    searchFieldsView: '.search-fields-view',
    customersGrid: '#customersGrid'
  },

  regions: {
    sideBar: '@ui.sideBar',
    searchFieldsView: '@ui.searchFieldsView',
    customersGrid: '@ui.customersGrid'
  },

  childViewEvents: {
    'search:response': 'onSearchResponse'
  },

  onSearchResponse(response) {
    this.$('.result-count').empty().append(`<span><b>Total Result Count: ${response.totalCount}</b></span>`);
    const users = _.map(response.users, (user) => ({ ...user, name: `${user.firstName} ${user.lastName}` }));

    this.customersGrid.collection.fullCollection.reset(users);
  },

  onRender() {
    this.showChildView('sideBar', new IntDashboardSidebarNavView({ mode: 'customers' }));

    const searchFields = [
      {
        id: 'firstName-search-field',
        name: 'firstName',
        class: 'InputSearchField',
        placeholder: 'First Name'
      },
      {
        id: 'lastName-search-field',
        name: 'lastName',
        class: 'InputSearchField',
        placeholder: 'Last Name'
      },
      {
        id: 'email-search-field',
        name: 'email',
        class: 'InputSearchField',
        placeholder: 'Email'
      },
      {
        id: 'command-search-field',
        name: 'commandName',
        class: 'InputSearchField',
        placeholder: 'Command Name'
      }
    ];

    this.showChildView(
      'searchFieldsView',
      lazyLoadView(() => loadSearchFields(searchFields, FindExternalUserByNameOrEmailOrCommandName))
    );

    this.customersGrid = new CustomerDashboardGridView({});

    this.showChildView('customersGrid', this.customersGrid);
  }
});

export default CustomerDashboardPage;
